import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { PatchVitalParams, VitalPayload } from "modules/vitals/types";
import { useQueryClient } from "react-query";

function usePatchVitalBMI(params: PatchVitalParams) {
  const queryClient = useQueryClient();
  const { encounterId } = params;
  return useAxiosMutation(
    ["patchVitalCheck"],
    (payload: VitalPayload) =>
      axiosChartInstance.patch(`v1/vitals/${encounterId}/vital-bmi`, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vitals"]);
        queryClient.invalidateQueries(["chartPatientCard", { encounterId }]);
      },
    }
  );
}

export { usePatchVitalBMI };
